import { render, staticRenderFns } from "./UnattestedBuildings.vue?vue&type=template&id=04fbedbb&scoped=true&"
import script from "./UnattestedBuildings.vue?vue&type=script&lang=js&"
export * from "./UnattestedBuildings.vue?vue&type=script&lang=js&"
import style0 from "./UnattestedBuildings.vue?vue&type=style&index=0&id=04fbedbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fbedbb",
  null
  
)

export default component.exports